// DateRow.jsx
import React from 'react';

export default function DateAndInvoiceRow({ 
  value, 
  onChange, 
  errorText, 
  required,
  invoiceNumber,
  onInvoiceChange,
  invoiceErrorText,
  disabled = false
 }) {
  return (
    <div style={{ display: "flex", gap: "20px", marginTop: 20 }}>
      <div className="form-input-expense">
        <label className="form-input-label-expense">Date*</label>
        <input
          type="date"
          name="date"
          className="form-input-field-expense"
          style={{width: 187}}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
        />
        {errorText ? <div className="error-text">{errorText}</div> : null}
      </div>
    </div>
  );
}
